<template>
	<layout-gestao>
		<div class="row">
			<div class="col-sm-12">
				<form
					autocomplete="off"
					method="post"
					:disabled="isLoading"
					data-vv-scope="form"
					@submit.prevent="saveItem">
					<div class="row mb-3">
						<div class="col-sm-auto">
							<h1 class="content-title">
								{{ titleItem }}
							</h1>
						</div>
					</div>
					<div class="row">
						<div class="col-md-8 col-sm-9">
							<div class="form-group">
								<MaterialInput
									id="input-description"
									v-model.trim="form.description"
									v-validate="'required|max:100'"
									:readonly="readonlyFormItem"
									type="text"
									class="city-form-group city-bg"
									name="description"
									:inputClasses="[{'is-invalid': fnHasError(`description`) }]"
									:error=" fnFirstError(`description`)">
									{{ $t(`${pageID}.model.name`) }}
								</MaterialInput>
							</div>
						</div>
						<div class="col-md-4 col-sm-3">
							<div class="form-group">
								<MaterialInput
									id="input-order"
									v-model.trim="form.order"
									v-validate="'required|integer|min_value:1'"
									:readonly="readonlyFormItem"
									type="number"
									class="city-form-group city-bg"
									name="order"
									:inputClasses="[{'is-invalid': fnHasError(`order`) }]"
									:error=" fnFirstError(`order`)"
									:helpText="'global_types.help.order'">
									{{ $t(`${pageID}.model.order`) }}
								</MaterialInput>
							</div>
						</div>
					</div>
					<hr>
					<div class="row">
						<div class="col-sm-12">
							<div class="form-group mb-0">
								<label class="d-block city-label">
									{{ $t(`${pageID}.form.relationship`) }}
								</label>
								<div class="d-flex flex-wrap d-sm-inline-flex">
									<div
										v-for="(target, index) in lists.relationship"
										:key="`relationship-${index}`"
										class="form-check city-form-check">
										<input
											class="form-check-input"
											type="checkbox"
											:id="`checkRelationship-${target.code}`"
											:name="`checkRelationship-${target.code}`"
											v-model="relationship"
											:value="target"
											:disabled="readonlyFormItem"
											v-validate="''"
										>
										<label class="form-check-label text-nowrap"
											:for="`checkRelationship-${target.code}`">
											{{ target.name }}
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="mt-3" :id="'accordion'">
						<div
							v-for="(item, index) in relationship"
							:key="index"
							class="card accordion">

							<div
								class="card-header px-4 py-2"
								data-toggle="collapse"
								:data-target="`#collapse-${index}`"
								:aria-expanded="true"
								:aria-controls="`collapse-${index}`">
								{{ item.name }}
							</div>
							<div
								:id="`collapse-${index}`"
								class="card-body py-4 collapse show"
								:aria-labelledby="`heading-${index}`">
								<div class="d-flex flex-wrap d-sm-inline-flex">
									<div
										v-for="(target, IndexRelationship) in getRelationshipList(item.code)"
										:key="IndexRelationship"
										class="form-check city-form-check">
											<input
												class="form-check-input"
												type="checkbox"
												:id="`checkTarget-${item.code}-${target.id}`"
												:name="`checkTarget-${item.code}-${target.id}`"
												v-model="form[`${item.code}_id`]"
												:value="target.id"
												:disabled="readonlyFormItem"
												v-validate="''"
											>
											<label
												class="form-check-label text-nowrap"
												:for="`checkTarget-${item.code}-${target.id}`">
												{{ target.name }}
											</label>

									</div>
								</div>
							</div>
						</div>
					</div>
					<hr>
					<buttons-footer
						:enableButtons="!readonlyFormItem"
						:cancelTitle="cancelTitle"
						:submitTitle="submitTitle"
						:isDisabled="isDisabled"
						@save="saveItem(`${moduleCode}.${pageID}`)"
						@cancel="handleBack(`${moduleCode}.${pageID}`)"/>
				</form>
			</div>
		</div>
	</layout-gestao>
</template>

<script>
	import mixin from '../../mixin';
	import { formatString } from '@config/utils.js';
	import { typeOfInterventions } from '../../shared/config';

	export default {
		name: "TypeGlobalForm",
		mixins: [
			mixin,
		],
		props: {
			propPageID: {
				required: true,
				type: String
			},
		},
		data() {
			return {
				autoloadItem: false,
				form: {
					id: null,
					description: null,
					color: null,
					order: 1,
				},
				relationship: [],
				lists: {
					loaded: false,
					entities: [],
					relationship: [],
				}
			}
		},
		beforeMount() {
			this.pageID = this.propPageID;
		},
		mounted() {
			this.loadLists()
			.then(res => {
				if(!res) return;

				this.loadItem()
                .then( res => {
                    if(res){
                        this.callbackLoadItem()
                    }
                });
			});
		},
		computed: {
			currentIntervention() {
				let choseItem = null
				typeOfInterventions.forEach(item => {
					let er = new RegExp(item.basePath);
					if(er.test(this.$route.path)) choseItem = item;
				});
				return choseItem;
			},
		},
		methods: {
			callbackLoadItem: function () {
				this.selectRelationship();
			},
			selectRelationship() {
				this.lists.relationship.forEach(item => {
					if(this.form[`${item.code}_id`].length > 0) {
						this.relationship.push(item);
					}
				});
			},
			getRelationshipList(code) {
				const item = this.lists.relationship.find((item) => { return item.code == code });
				return item.list || [];
			},
			loadTypeRel(code) {
				const idxItem = this.lists.relationship.findIndex((item) => { return item.code == code });
				if(idxItem > -1) {
					const url = formatString(this.url.getRelationship, {code});
					this.$http.get(url)
					.then(({data}) => {
						this.lists.relationship[idxItem].list = data.data;
					}).catch(error => {
						this.showHttpError(error);
					});
				}
			},
			loadRelationship() {
				this.relationship.forEach(item => {
					const index = this.lists.relationship.findIndex(relation => {
						return relation.code == item.code;
					});
					if(this.lists.relationship[index].list.length == 0) {
						this.loadTypeRel(item.code);
					}
				});
			},
		},
		watch: {
			'lists.entities': {
				deep: true,
				immediate: true,
				handler(newValue, oldValue) {
					let entities = newValue;
					let relationship = [];
					if(this.currentIntervention !== null) {
						entities = entities.filter(item => {
							return item.code == this.currentIntervention.key;
						});
					}
					entities.forEach(item => {
						relationship.push({
							...item,
							list: []
						});
						this.$set(this.form, `${item.code}_id`, []);
					});
					this.lists.relationship = relationship;
				}
			},
			relationship: function(newValue, oldValue) {
				if(newValue && oldValue && newValue.length < oldValue.length) {
					let newCodes = newValue.map(value => value.code);
					oldValue.filter(item => !newCodes.includes(item.code))
					.forEach(item => {
						this.form[`${item.code}_id`].splice(0);
					});
				}else{
					this.loadRelationship();
				}
			},
		},
	}
</script>
